import { defineStore } from 'pinia';
import { DictionaryWlListItem } from '@/models/whitelabel-list/whitelabel-list.model';

interface MultiWhitelabelListState {
  multiWhitelabelList: DictionaryWlListItem[];
}

export const useMultiWhitelabelListStore = defineStore('MultiWhitelabelListStore', {
  state: (): MultiWhitelabelListState => ({
    multiWhitelabelList: [],
  }),
  getters: {
    multiWhitelabelIdList(state: MultiWhitelabelListState): string[] {
      return state.multiWhitelabelList.map(({ id }: DictionaryWlListItem) => id);
    },
    multiWhitelabelSlugList(state: MultiWhitelabelListState): string[] {
      return state.multiWhitelabelList.map(({ slug }: DictionaryWlListItem) => slug);
    },
  },
  actions: {
    setMultiWhitelabelList(multiWhitelabelList: DictionaryWlListItem[]): void {
      this.multiWhitelabelList = multiWhitelabelList;

      sessionStorage.setItem(
        'multiWhitelabelSlugList',
        JSON.stringify(this.multiWhitelabelSlugList),
      );
    },
    restoreMultiWhitelabelList(whitelabelList: DictionaryWlListItem[]): void {
      const storedSlugList = JSON.parse(
        sessionStorage.getItem('multiWhitelabelSlugList') ?? '[]',
      ) as string[];

      this.multiWhitelabelList = whitelabelList.filter(({ slug }) =>
        storedSlugList.includes(slug),
      );
    },
  },
});
